<template>
  <div>
    <router-view />
  </div>
</template>


<script>
export default {
  mounted() {
    this.$store.dispatch("title/getTitles", { page: 0, limit: 50 });
  },
};
</script>
<style>
@import "~@fortawesome/fontawesome-free/css/all.css";
[data-f-id] {
  display: none !important;
  opacity: 0;
  visibility: hidden;
}
[href*="https://www.froala.com"]
{
  display: none !important;
  opacity: 0;
  visibility: hidden;
}
</style>
